import apiBase from "./apiBase";

export async function getSpecimen(params) {
    const result = await apiBase.simpleGetAsync("/specimen", { params: params });

    return result.data;
}

export async function getSpecimenVenomTypes(params) {
    const result = await apiBase.simpleGetAsync("/specimen/venomtypes", {params: params});
    return result.data;
}